export default __webpack_public_path__ + "static/media/B1.870ab0bf.png";